import React from "react";
import Carousel from "react-material-ui-carousel";
import { Paper, Box, useMediaQuery, useTheme } from "@mui/material";
const Banner = () => {
  const banners = [
    {
      id: 1,
      image: "/images/banner1.jpg",
    },
    {
      id: 2,
      image: "/images/banner2.jpg",
    },
    {
      id: 3,
      image: "/images/banner3.webp",
    },
    {
      id: 4,
      image: "/images/banner4.jpg",
    },
  ];
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box id="home">
      <Carousel
        autoPlay={true}
        animation="fade"
        navButtonsAlwaysVisible={!isMobile}
        indicators={false}
        fullHeightHover={false}
      >
        {banners.map((banner) => (
          <Paper key={banner.id} elevation={0}>
            <Box
              component="img"
              src={banner.image}
              alt={`Banner ${banner.id}`}
              sx={{
                width: "100%",
                height: isMobile ? "500px" : "100vh",
                objectFit: "cover",
              }}
            />
          </Paper>
        ))}
      </Carousel>
    </Box>
  );
};
export default Banner;
